import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgValidationCheckBold48 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M11 24.8846C14.5194 27.2936 20.7491 34.4078 22.7064 39C25.68 28.7992 33.3965 14.1192 37.3488 9" stroke="currentColor" strokeWidth={2.6} strokeLinecap="square" /></svg>;
const ForwardRef = forwardRef(SvgValidationCheckBold48);
export default ForwardRef;